// File Metadata:
// Filename: NewReception.js
// Version: 1.00
// Created: 2022-09-28 22:17:23
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import NewReceptionForm from './NewReceptionForm'
import { useGetVendorsQuery } from '../api/vendorsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'

const NewReception = () => {
	const { vendors } = useGetVendorsQuery('vendorsList', {
		selectFromResult: ({ data }) => ({
			vendors: data?.ids.map(id => data?.entities[id])
		})
	})

	if (!vendors?.length) return <PulseLoader color='#fff' />
	console.log(vendors)

	const content = <NewReceptionForm vendors={vendors} />

	return content
}

export default NewReception
